import { Flex } from "@chakra-ui/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ContractTaskDto } from "../../../../../../autogen/bff-api";
import { ContractTaskStatusTag } from "../../ContractTaskStatusTag";
import { EditButton } from "../EditButton";
import { EditStatus } from "./EditStatus";

interface Props {
  task: ContractTaskDto;
}

export const Status = ({ task }: Props) => {
  const { t } = useTranslation();
  const [isEditing, setIsEditing] = useState(false);

  return (
    <Flex mt="10px" w="100%">
      {!isEditing && (
        <Flex>
          <ContractTaskStatusTag status={task.displayStatus} size={"md"} />
          {task.canChangeStatus && <EditButton name="edit-status-button" label={t("Edit status")} onClick={() => setIsEditing(true)} />}
        </Flex>
      )}
      {isEditing && (
        <EditStatus
          task={task}
          onEditComleted={() => setIsEditing(false)}
          onCancel={() => setIsEditing(false)}
        />
      )}
    </Flex>
  );
};
